import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportCriteriaModel, ReportQueryModel, ReportQueryResultsModel, ReportViewModel } from './report-view-model';
import { DescriptionModel } from '../base.model';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  apiBaseUrl: string;
  constructor(
    private httpClient: HttpClient,        
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.apiBaseUrl = baseUrl;
  }

  public GetReport(reportCriteriaModel: ReportQueryModel): Observable<ReportQueryResultsModel> {
    var reqHeader = new HttpHeaders({
      'Content-Type': 'application/json',
      'No-Error-Message': 'True',
    });
    return this.httpClient
      .post<ReportQueryResultsModel>(
        AppConfig.settings.settings.apiEndpoint + 'api/Report/GetReportsData',
        reportCriteriaModel,
        { headers: reqHeader }
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  public GetReportNames(): Observable<any> {
    return this.httpClient
      .get<any>(AppConfig.settings.settings.apiEndpoint + 'api/Report/GetReportNames')
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  public GetReportNamesByReportRange(fromReportId: number, toReportId: number): Observable<DescriptionModel[]> {
    return this.httpClient
      .get<DescriptionModel[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/Report/GetReportNamesByReportRange?fromReportId=` +
          fromReportId +
          '&toReportId=' +
          toReportId
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  public GetReportDates(reportType: Number, clientId: Number, isFileDocument: boolean): Observable<any> {
    return this.httpClient.get<any>(
      AppConfig.settings.settings.apiEndpoint +
        'api/Report/GetReportDates/' +
        reportType + '/' +  clientId + '/' + isFileDocument
    );
  }

  exportCandidatesCall() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post(
      AppConfig.settings.settings.apiEndpoint + 'api/Report/GetReportDates/',
      headers,
      { observe: 'body', responseType: 'blob' }
    );
  }
}
